import React, { useEffect, useState } from "react";
import {
    Button,
    Col,
    Form,
    Row,
    ToggleButton,
    ToggleButtonGroup,
} from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import TinyEditor from "../../components/Editor";
import { store } from "../..";
import { globalActions, selectNotice } from "../../features/global/globalSlice";
import { ISiteNoticeForm } from "../../types/forms";
import ReactDatePicker from "react-datepicker";

export const loader = async () => {
    let notice = store.getState().global.notice;

    const noticePromise = notice
        ? Promise.resolve()
        : store.dispatch(globalActions.getNotice());

    await Promise.all([noticePromise]);

    return null;
};

const SiteNotice = (): React.JSX.Element | undefined => {
    const dispatch = useAppDispatch();
    const notice = useAppSelector(selectNotice);
    const [editorValue, setEditorValue] = useState<string>(
        notice?.notice || "",
    );

    const methods = useForm<ISiteNoticeForm>({
        mode: "onChange",
        defaultValues: {
            siteNotice: notice?.notice,
        },
    });

    const onSubmit: SubmitHandler<ISiteNoticeForm> = async data => {
        await dispatch(globalActions.updateNotice(data));
    };

    const watchNotice = methods.watch(
        "siteNotice",
        methods.getValues("siteNotice"),
    );

    return (
        <section className="siteSettingsWaiverContent">
            <Form onSubmit={methods.handleSubmit(onSubmit)}>
                <Row>
                    <Col>
                        <h6>
                            Site notice will automatically display until
                            midnight of the current day as long as there is a
                            notice set in the text editor below.
                            <br />
                            To clear the notice early, clear all content in the
                            text editor and click the "Update Site Notice"
                            button.
                        </h6>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col>
                        <Form.Control
                            type="hidden"
                            {...methods.register("siteNotice", {
                                value: watchNotice
                                    ? "true"
                                    : methods.getValues("siteNotice") ||
                                      editorValue,
                            })}
                        />
                        <TinyEditor
                            editorValue={editorValue}
                            showSave={false}
                            formField="siteNotice"
                            formMethods={methods}
                            setEditorValue={setEditorValue}
                        />
                    </Col>
                </Row>
                <Button variant="primary" type="submit">
                    Update Site Notice
                </Button>
            </Form>
        </section>
    );
};

export default SiteNotice;
